import React, { useState } from 'react'
import { Alert } from 'react-bootstrap'

/**
 * Dismissible warning shown inside the email-verification modal when another
 * page stored a reason for forcing verification (charity registration,
 * src/pages/charities/search/list.jsx sets `verify-email-message`).
 *
 * The message is read once on mount — the modal unmounts its body when
 * hidden, so this re-reads localStorage each time it opens. The key is left
 * in localStorage until dismissal because the post-verification redirect in
 * edit.jsx keys off its presence.
 */
export default function VerifyEmailAlert() {
  const [message, setMessage] = useState(() =>
    localStorage.getItem('verify-email-message'),
  )

  if (!message) return null

  return (
    <Alert
      variant="warning"
      onClose={() => {
        localStorage.removeItem('verify-email-message')
        setMessage(null)
      }}
      dismissible
    >
      <p>{message}</p>
    </Alert>
  )
}
